import { HiAdjustmentsHorizontal } from "react-icons/hi2";

export const Filter = ({ width, height, color, ...props }) => (
  <HiAdjustmentsHorizontal
    size={width || height || 24}
    color={color || "currentColor"}
    {...props}
  />
);
